<script setup lang="ts">
    import Loading from '~/components/ui/Loading.vue'
    const emit = defineEmits(["init"])
    onMounted(() => {
        emit("init")
    })
</script>
<template>
    <Loading />
</template>
<style>

.spinner {
    border-top-color:var(--red-1);
}
</style>
